import { useCallback, useEffect } from 'react';

import { LastInteractedStoreModel } from './machine/LastInteractedStore.model';
import { useLastInteractedStoreMachine } from './useLastInteractedStoreMachine';

import type { LastInteractedStore } from './machine/LastInteractedStore.model';

/**
 * Sets the last interacted menu store if it is resolved.
 */
export const useSetLastInteractedMenuStore = (
  lastInteractedMenuStore: LastInteractedStore = {},
) => {
  const [, send] = useLastInteractedStoreMachine();

  const {
    restaurantId,
    restaurantName,
    restaurantSlug,
    addressId,
    deliveryFee,
    vendor,
    vendorRestaurantId,
  } = lastInteractedMenuStore;

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const setLastInteractedMenuStore = useCallback(
    (store: LastInteractedStore = {}) => {
      const {
        restaurantId,
        restaurantName,
        restaurantSlug,
        addressId,
        deliveryFee,
        vendor,
        vendorRestaurantId,
      } = store;

      if (!restaurantSlug && !addressId) return;

      send(
        SET_LAST_INTERACTED_MENU_STORE({
          restaurantId,
          restaurantName,
          addressId,
          restaurantSlug,
          deliveryFee,
          vendor,
          vendorRestaurantId,
        }),
      );
    },
    [send],
  );

  // ─── Effects ───────────────────────────────────────────────────────────────

  useEffect(() => {
    setLastInteractedMenuStore({
      restaurantId,
      restaurantName,
      addressId,
      restaurantSlug,
      deliveryFee,
      vendor,
      vendorRestaurantId,
    });
  }, [
    restaurantId,
    restaurantName,
    addressId,
    restaurantSlug,
    deliveryFee,
    vendor,
    vendorRestaurantId,
    setLastInteractedMenuStore,
  ]);

  return setLastInteractedMenuStore;
};

// ────────────────────────────────────────────────────────────────────────────────

const { SET_LAST_INTERACTED_MENU_STORE } = LastInteractedStoreModel.events;
